'use client'
import Image from "next/image";
import Link from "next/link";
import { customImageLoader } from "@/lib/utils/customLoader";
import dynamic from "next/dynamic";

// dynamic import component
const BannerTracker = dynamic(() => import("./BannerTracker"))

type Props = {
  divId: string;
  bannerImage: string;
  bannerText: string;
  redirectUrl: string;
  campaignId: string;
  platformId: string;
  brand: string;
  deviceType: string;
  isExternal: boolean;
  state?: string;
  city?: string;
  placeholderId: string;
  d_width: number;
  d_height: number;
  priority?: boolean;
};

export default function BMSBannerLoader({
  divId,
  bannerImage,
  bannerText,
  redirectUrl,
  campaignId,
  platformId,
  brand,
  deviceType,
  isExternal,
  state = "",
  city = "",
  placeholderId,
  d_width,
  d_height,
  priority = true,
}: Props) {
  const image = (
    <Image
      src={bannerImage}
      alt={bannerText}
      title={bannerText}
      width={d_width}
      height={d_height}
      priority={priority}
      loader={customImageLoader}
      sizes="100vw"
      fetchPriority={priority ? "high" : "auto"}
      loading={priority ? "eager" : "lazy"}
    />
  );

  return (
    <>
      <BannerTracker
        divId={divId}
        campaignId={campaignId}
        platformId={platformId}
        brand={brand}
        deviceType={deviceType}
        placeholderId={placeholderId}
      />

      {!redirectUrl ? (
        <div id={divId}>
          {image}
        </div>
      ) : (
        <Link
          id={divId}
          href={redirectUrl}
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noopener noreferrer" : undefined}
          prefetch={false}
          title="Banner Image"
        >
          {image}
        </Link>
      )}
    </>
  );
}